import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Link as WouterLink } from "wouter";
import { resolveCdnAssetUrl } from "../utils/cdnAssetUrl";

import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import type { ReactElement } from "react";

const IMAGE_404_URL = resolveCdnAssetUrl("404.svg");
const DATA_GRAPHIC_URL = resolveCdnAssetUrl("data-graphic-long.svg");

export default function PageNotFound(): ReactElement {
  return (
    <Container
      sx={{
        minHeight: { lg: "60vh" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        overflow: "hidden",
        pt: 10,
        pb: 5,
      }}
    >
      <Stack direction={{ sm: "column", md: "row" }} mt={10} spacing={6}>
        <Box
          component="img"
          src={IMAGE_404_URL}
          alt="404 - Page Not Found"
          sx={{
            maxWidth: { sm: "100%", md: "50%", lg: "100%" },
            height: "auto",
          }}
        />
        <Stack alignItems="start" spacing={1} maxWidth="600px">
          <Typography variant="h5">
            Oops! You dove right in to a page that doesn’t exist. Let’s find
            some other places for you to check out.
          </Typography>
          <WouterLink href="/">
            <Typography
              variant="body1"
              color="primary"
              alignItems={"center"}
              display={"flex"}
            >
              Go back home <ArrowForwardRoundedIcon fontSize="small" />
            </Typography>
          </WouterLink>
          <Link
            href="https://docs.mydecisive.ai/index.html"
            underline="hover"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Typography
              variant="body1"
              color="primary"
              alignItems={"center"}
              display={"flex"}
            >
              Check out our docs <ArrowForwardRoundedIcon fontSize="small" />
            </Typography>
          </Link>
        </Stack>
      </Stack>
      <Box
        component="img"
        src={DATA_GRAPHIC_URL}
        alt="data graphic"
        pt={{ sm: 10, md: 20 }}
        pb={4}
        px={0}
      ></Box>
    </Container>
  );
}
